import React from 'react';
import { getImageUrl } from '../utils/Utils';

const Image = (props) => {
  const { src } = props;

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      src={getImageUrl(src)}
    />
  );
};

export default Image;
